module.exports = __webpack_public_path__ + "img/line-chart-up-03.7da4841c.svg";